import { render, staticRenderFns } from "./ScreenLocker.vue?vue&type=template&id=3bd5fbf3&scoped=true&"
import script from "./ScreenLocker.vue?vue&type=script&lang=js&"
export * from "./ScreenLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5fbf3",
  null
  
)

export default component.exports